import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "n-icon-chevron-right",
  "use": "n-icon-chevron-right-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"n-icon-chevron-right\">\n    <path d=\"M11.6983 10L8.2318 14.3598C7.87824 14.7841 7.93556 15.4147 8.35984 15.7682C8.78412 16.1218 9.41468 16.0645 9.76825 15.6402L13.7682 10.6402C14.0773 10.2694 14.0773 9.73069 13.7682 9.35984L9.76825 4.35984C9.41468 3.93556 8.78412 3.87824 8.35984 4.2318C7.93556 4.58537 7.87824 5.21593 8.2318 5.64021L11.6983 10Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol